import FingerprintJS from '@fingerprintjs/fingerprintjs'
import { cacheStore } from '../caches/store'

const KEY_DV_ID = 'dv_id'

function getDeviceId() {
  return cacheStore.getItem(KEY_DV_ID)
}
function setDeviceId(id: string) {
  return cacheStore.setItem(KEY_DV_ID, id)
}

/** 获取设备id */
export async function createDeviceId() {
  let id = getDeviceId()
  if (id) return id

  const fp = await FingerprintJS.load({ debug: false })
  const result = await fp.get()
  id = result.visitorId
  setDeviceId(id)
  return id
}

export function isMobile() {
  const flag =
    navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    ) || document.body.clientWidth < 800
  return flag
}
function mobileType() {
  const u = navigator.userAgent
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  return isiOS ? 'IOS' : 'ANDROID'
}

/** 获取设备类型 */
export function getOS() {
  if (isMobile()) {
    return mobileType()
  } else {
    return 'PC'
  }
}

// 定义校验函数
export function validateSchema(data: any, schema: any) {
  // 验证上报数据必须是一个对象
  if (typeof data !== 'object') {
    return { valid: false, error: '' }
  }

  // 验证必要字段是否存在
  for (const field of schema.required) {
    if (!(field in data)) {
      return { valid: false, error: `缺少必要字段 ${field}` }
    }
  }
  const typeNameMap = {
    string: '文本',
    number: '数值',
    boolean: '布尔',
  } as const
  // 验证字段类型是否匹配
  for (const field in data) {
    const expectedType = schema.properties[field]?.type
    if (expectedType) {
      const typeName = typeNameMap[expectedType as keyof typeof typeNameMap]

      const actualType = typeof data[field]
      if (expectedType !== actualType) {
        return { valid: false, error: `字段 ${field} 类型应为 ${typeName}` }
      }
    }
  }

  // 数据合法
  return { valid: true }
}
